import React from "react";

const CopyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="copy_icon"
      data-name="copy"
      {...props}
      width={props.width || "24"}
      height={props.height || "25"}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2.52637H10C8.897 2.52637 8 3.42337 8 4.52637V8.52637H4C2.897 8.52637 2 9.42337 2 10.5264V20.5264C2 21.6294 2.897 22.5264 4 22.5264H14C15.103 22.5264 16 21.6294 16 20.5264V16.5264H20C21.103 16.5264 22 15.6294 22 14.5264V4.52637C22 3.42337 21.103 2.52637 20 2.52637ZM4 20.5264V10.5264H14L14.002 20.5264H4ZM20 14.5264H16V10.5264C16 9.42337 15.103 8.52637 14 8.52637H10V4.52637H20V14.5264Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default CopyIcon;
